import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import AdditionalServicesUtilitiesCalculation from 'components/AdditionalServices/AdditionalServicesUtilitiesCalculation'

const AdditionalServicesMediaPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesUtilitiesCalculation />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesMediaPage
